import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-error-dialog',
	styles: [
		`
			.error-message {
				padding: 1rem 0;
			}
		`,
	],
	templateUrl: './error-dialog.component.html',
})
export class ErrorDialogComponent {
	errorMessage: string;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: string,
		private readonly dialogRef: MatDialogRef<ErrorDialogComponent>,
	) {
		this.errorMessage = data;
	}

	closeModal(retry?: boolean): void {
		this.dialogRef.close(retry);
	}
}
